const carouselItems = [
  {
    title: '2025娱乐圈年度塌房大盘点',
    desc: '从顶流到网红，谁能想到这些人设崩塌得如此彻底？全面回顾今年最劲爆的明星翻车事件。',
    tag: '年度专题',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20year%20in%20review%20collage%20of%20entertainment%20scandals%2C%20broken%20pedestals%20and%20falling%20stars%2C%20moody%20crimson%20and%20black%20atmosphere%2C%20cinematic%20noir%2C%20editorial%20newspaper%20aesthetic&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '网红带货：暴利背后的灰色产业链',
    desc: '深入揭秘直播带货行业选品、刷单、售后全链条，那些你看到的"爆单"背后藏着什么？',
    tag: '深度报道',
    img: 'https://readdy.ai/api/search-image?query=Dark%20behind%20the%20scenes%20of%20live%20commerce%20industry%2C%20shadow%20figures%20handling%20products%20and%20money%2C%20moody%20noir%20lighting%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20photography&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '从恋爱到撕逼：明星情侣分手经济学',
    desc: '当爱情变成公关危机，明星分手声明背后的商业博弈与形象管理，比你想象的更复杂。',
    tag: '独家分析',
    img: 'https://readdy.ai/api/search-image?query=Dark%20split%20composition%20of%20two%20sides%2C%20celebrity%20relationship%20drama%20visual%2C%20crimson%20and%20black%20contrast%2C%20moody%20atmosphere%2C%20cinematic%20noir%20style%2C%20editorial%20photography&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '爆料文化简史：吃瓜群众是如何炼成的',
    desc: '从论坛时代到短视频时代，互联网爆料文化二十年的变迁，以及吃瓜作为社交货币的崛起。',
    tag: '文化观察',
    img: 'https://readdy.ai/api/search-image?query=Dark%20timeline%20evolution%20of%20internet%20gossip%20culture%2C%20retro%20to%20modern%20screens%2C%20moody%20noir%20lighting%2C%20crimson%20accents%2C%20cinematic%20composition%2C%20editorial%20style&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '选秀节目的幕后：那些不为人知的规则',
    desc: '从选手签约到投票操纵，业内人士匿名揭秘选秀节目背后的资本游戏与暗箱操作。',
    tag: '业内人士爆料',
    img: 'https://readdy.ai/api/search-image?query=Dark%20stage%20behind%20the%20curtain%20revealing%20hidden%20machinery%2C%20talent%20show%20backstage%20secrets%2C%20moody%20crimson%20and%20black%20lighting%2C%20cinematic%20noir%2C%20dramatic%20shadows&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    title: '吃瓜安全指南：网络爆料的法律边界',
    desc: '吃瓜有风险，转发需谨慎。解读网络爆料涉及的名誉权、隐私权与信息网络传播相关法律红线。',
    tag: '科普专题',
    img: 'https://readdy.ai/api/search-image?query=Dark%20legal%20documents%20and%20scales%20of%20justice%20in%20shadow%2C%20internet%20law%20theme%2C%20moody%20noir%20lighting%2C%20crimson%20and%20black%20tones%2C%20professional%20editorial%20photography&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">焦点专题</h2>
            <p className="text-sm text-foreground-500">精选深度专题报道，全方位解读热门事件</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item, i) => (
              <article key={i} className="bg-background-50 rounded-lg overflow-hidden border border-background-300/40 hover:border-background-300/70 transition-all duration-200 group">
                <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-[10px] font-medium bg-accent-500/90 text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-400 transition-colors">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}